export const FETCH_USER_LIST = 'FETCH_USER_LIST';
export const BAN_USER_LIST_ITEMS = 'BAN_USER_LIST_ITEMS';
export const SET_USER_LIST_PAGINATION_DATA = 'SET_USER_LIST_PAGINATION_DATA';
export const TOGGLE_EVENT_USER_ROW = 'TOGGLE_EVENT_USER_ROW';
export const DELETE_EVENT_USER_ROW = 'DELETE_EVENT_USER_ROW';
export const SET_EVENT_USER_FILTER = 'SET_EVENT_USER_FILTER';
export const CLEAR_EVENT_USER_FILTER = 'CLEAR_EVENT_USER_FILTER';
export const SET_EVENT_USER_SORT = 'SET_EVENT_USER_SORT';
export const SET_EVENT_USER_SHARE_PLATFORMS = 'SET_EVENT_USER_SHARE_PLATFORMS';
